export const scrollTop = {
  mounted() {
	  window.scrollTo(0,0);
  },
};



// WEBPACK FOOTER //
// ./src/plugins/scrollTopMixin.js